import { create } from "zustand";

type MerchantStore = {
  setMerchant: (id: number) => void;
  selectedMerchant: number | null;
  isSelfSellCar: boolean;
};

export const useMerchantStore = create<MerchantStore>()(set => ({
  setMerchant: (id: number) => set({ selectedMerchant: id, isSelfSellCar: Number(id) === 2 }),
  isSelfSellCar: false,
  selectedMerchant: null,
}));
